"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const axios_1 = __importDefault(require("axios"));
const URLs_1 = require("../utility/URLs");
const helpers_1 = require("../../commonFiles/helpers");
const stateActions_1 = require("../redux/stateActions");
const react_redux_1 = require("react-redux");
function LoginPage(props) {
    const [username, setusername] = react_1.default.useState('');
    const [password, setpassword] = react_1.default.useState('');
    function handleLogin(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () {
                yield axios_1.default.get('/sanctum/csrf-cookie');
                return yield URLs_1.Api.login(username, password);
            }), (data) => {
                props.refreshAdmin(data);
                // setredirect(Routes.dashboard())
            }, 'handleLogin', true);
            // try {
            //     await axios.get('/sanctum/csrf-cookie')
            //     const response = await Api.login(username, password)
            //     console.log('Admin signed in!', (response.data));
            //     props.refreshAdmin(response.data)
            //     setredirect(Routes.dashboard())
            // } catch (error) {
            //     logError(error)
            // }
        });
    }
    react_1.default.useEffect(() => {
        if (props.admin) {
            // setredirect(Routes.dashboard())
        }
    }, [props.admin]);
    return (react_1.default.createElement("div", { className: 'col-5 mx-auto border shadow p-3 mt-5 rounded' },
        react_1.default.createElement("div", { className: '' },
            react_1.default.createElement("h4", { className: 'text-center m-3' }, "\u0645\u0631\u062D\u0628\u0627\u064B \u0628\u0639\u0648\u062F\u062A\u0643!"),
            react_1.default.createElement("div", { className: 'bg-white shadow rounded p-3 m-1' },
                react_1.default.createElement("div", { className: 'd-flex my-2' },
                    react_1.default.createElement("div", { className: 'mx-2 col-2' }, "\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645:"),
                    react_1.default.createElement("input", { type: 'username', className: 'form-control', onChange: e => setusername(e.target.value) })),
                react_1.default.createElement("div", { className: 'd-flex my-2' },
                    react_1.default.createElement("div", { className: 'mx-2 col-2' }, "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631:"),
                    react_1.default.createElement("input", { type: 'password', className: 'form-control', onChange: e => setpassword(e.target.value) }))),
            react_1.default.createElement("button", { type: "button", className: "btn btn-light bg-white shadow w-100 my-1", onClick: () => handleLogin(username, password) }, "\u062F\u062E\u0648\u0644"))));
}
const mapStateToProps = state => {
    return {
        admin: state.state.admin,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        refreshAdmin: (admin) => dispatch((0, stateActions_1.refreshAdmin)(admin)),
    };
};
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(LoginPage);
